export default __webpack_public_path__ + "static/rovo-overlay-remix2-dark-234bf0884b97411ea736942f5fdd3b18a009b23f064cf930a68429bba984c41b.png";